import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const TermsOfService = () => {
  return (
    <div style={{padding:24}}>
      <h1 className="page-title">Terms of Service</h1>
      <div className="page-content" style={{ marginTop: 12, color: '#6b7280' }}>
        <p>
          These Terms of Service explain the relationship between OneAI and people who use our website and tools. They describe permitted uses, account responsibilities, and the general rules that allow us to operate a safe, reliable service. By using OneAI you agree to follow these terms; they are intended to protect both users and the platform and to set clear expectations about data, usage, and dispute resolution.
        </p>

        <p>
          We balance innovation with user safety by defining acceptable content, payment and cancellation rules, and limits on liability. These terms also clarify ownership and responsibility for content you submit, including best practices for avoiding sharing sensitive or confidential information. For organizations using OneAI, we offer additional contractual options to address data residency, custom SLAs, and enterprise support.
        </p>

        <ul style={{ marginTop: 8 }}>
          <li>Clear rules for acceptable use and content responsibilities.</li>
          <li>Transparent billing, cancellation, and dispute procedures.</li>
          <li>Options for enterprise agreements and data protections.</li>
        </ul>

        <p style={{ marginTop: 12 }}>
          If you have questions about specific clauses or need clarification about how these Terms apply to your use case, contact our support or legal team at info.onehubtech@gmail.com. We aim to be responsive and to provide practical guidance where needed.
        </p>

        <p>
          These Terms are written to be straightforward and actionable; they protect you and the community while enabling OneAI to provide robust, reliable tools. Review them periodically — updates may be posted and will be effective as described in the notice section below.
        </p>
        <p style={{ marginTop: 12 }}>
          We also include information on account security, data retention, and how we handle takedown or copyright claims. Keeping your account secure and following the reporting process helps protect other users and ensures the platform continues to operate smoothly. If you operate on behalf of an organization, you are responsible for supervising account usage and ensuring compliance with these Terms across your team.
        </p>

        <p>
          In short, these Terms are designed to be practical: they explain what OneAI provides, what we expect from users, and how you can get help if problems arise. They make it easier to use our services responsibly and to understand the boundaries that keep the community safe.
        </p>
      </div>

      <p>Last updated: {new Date().toISOString().split('T')[0]}</p>

      <p>Welcome to OneAI. By using our website and services, you agree to these Terms of Service. Please read them carefully.</p>

      <h3>Use of service</h3>
      <p>You may use the Site for lawful purposes only. You are responsible for any content you submit and must respect copyrights and third-party rights.</p>

      <h3>Subscriptions & payments</h3>
      <p>Paid features and subscriptions are processed through Razorpay. All payment terms, refunds, and disputes are subject to Razorpay's policies as well as our own Payment Policy (see Payment Policy).</p>

      <h3>Limitation of liability</h3>
      <p>To the maximum extent permitted by law, OneAI is not liable for indirect, incidental, or consequential damages arising from use of the Service.</p>

      <h3>Contact</h3>
      <p>If you have questions about these Terms, contact info.onehubtech@gmail.com.</p>

      {/* Internal navigation for SEO and discovery */}
      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
